export default import.meta.ROLLDOWN_FILE_URL_M6pSOTQsTbzFZtJEdPfJ0Q